import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaDatePicker from './VaDatePicker.vue'

export const VaDatePicker = withConfigTransport(_VaDatePicker)
